var endpointMap = {
	ar: {
		htmlTest: "translation-ar.json",
		pluralTest: "translation-ar.json",
		strings: "translation-ar.json"
	},
	"ar-AE": {
		htmlTest: "translation-ar.json",
		pluralTest: "translation-ar.json",
		strings: "translation-ar.json"
	},
	bn: {
		htmlTest: "translation-bn.json",
		pluralTest: "translation-bn.json",
		strings: "translation-bn.json"
	},
	"bn-IN": {
		htmlTest: "translation-bn.json",
		pluralTest: "translation-bn.json",
		strings: "translation-bn.json"
	},
	cs: {
		htmlTest: "translation-cs.json",
		pluralTest: "translation-cs.json",
		strings: "translation-cs.json"
	},
	"cs-CZ": {
		htmlTest: "translation-cs.json",
		pluralTest: "translation-cs.json",
		strings: "translation-cs.json"
	},
	da: {
		htmlTest: "translation-da.json",
		pluralTest: "translation-da.json",
		strings: "translation-da.json"
	},
	"da-DK": {
		htmlTest: "translation-da.json",
		pluralTest: "translation-da.json",
		strings: "translation-da.json"
	},
	de: {
		htmlTest: "translation-de.json",
		pluralTest: "translation-de.json",
		strings: "translation-de.json"
	},
	"de-DE": {
		htmlTest: "translation-de.json",
		pluralTest: "translation-de.json",
		strings: "translation-de.json"
	},
	en: {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-AE": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-AU": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-CA": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-GB": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-IE": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-IN": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-SG": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-US": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	"en-ZA": {
		htmlTest: "translation-en.json",
		pluralTest: "translation-en.json",
		strings: "translation-en.json"
	},
	es: {
		htmlTest: "translation-es.json",
		pluralTest: "translation-es.json",
		strings: "translation-es.json"
	},
	"es-ES": {
		htmlTest: "translation-es.json",
		pluralTest: "translation-es.json",
		strings: "translation-es.json"
	},
	"es-MX": {
		htmlTest: "translation-es.json",
		pluralTest: "translation-es.json",
		strings: "translation-es.json"
	},
	"es-US": {
		htmlTest: "translation-es.json",
		pluralTest: "translation-es.json",
		strings: "translation-es.json"
	},
	fr: {
		htmlTest: "translation-fr.json",
		pluralTest: "translation-fr.json",
		strings: "translation-fr.json"
	},
	"fr-BE": {
		htmlTest: "translation-fr.json",
		pluralTest: "translation-fr.json",
		strings: "translation-fr.json"
	},
	"fr-CA": {
		htmlTest: "translation-fr.json",
		pluralTest: "translation-fr.json",
		strings: "translation-fr.json"
	},
	"fr-FR": {
		htmlTest: "translation-fr.json",
		pluralTest: "translation-fr.json",
		strings: "translation-fr.json"
	},
	he: {
		htmlTest: "translation-he.json",
		pluralTest: "translation-he.json",
		strings: "translation-he.json"
	},
	"he-IL": {
		htmlTest: "translation-he.json",
		pluralTest: "translation-he.json",
		strings: "translation-he.json"
	},
	hi: {
		htmlTest: "translation-hi.json",
		pluralTest: "translation-hi.json",
		strings: "translation-hi.json"
	},
	"hi-IN": {
		htmlTest: "translation-hi.json",
		pluralTest: "translation-hi.json",
		strings: "translation-hi.json"
	},
	id: {
		htmlTest: "translation-id.json",
		pluralTest: "translation-id.json",
		strings: "translation-id.json"
	},
	"id-ID": {
		htmlTest: "translation-id.json",
		pluralTest: "translation-id.json",
		strings: "translation-id.json"
	},
	it: {
		htmlTest: "translation-it.json",
		pluralTest: "translation-it.json",
		strings: "translation-it.json"
	},
	"it-IT": {
		htmlTest: "translation-it.json",
		pluralTest: "translation-it.json",
		strings: "translation-it.json"
	},
	ja: {
		htmlTest: "translation-ja.json",
		pluralTest: "translation-ja.json",
		strings: "translation-ja.json"
	},
	"ja-JP": {
		htmlTest: "translation-ja.json",
		pluralTest: "translation-ja.json",
		strings: "translation-ja.json"
	},
	kn: {
		htmlTest: "translation-kn.json",
		pluralTest: "translation-kn.json",
		strings: "translation-kn.json"
	},
	"kn-IN": {
		htmlTest: "translation-kn.json",
		pluralTest: "translation-kn.json",
		strings: "translation-kn.json"
	},
	ko: {
		htmlTest: "translation-ko.json",
		pluralTest: "translation-ko.json",
		strings: "translation-ko.json"
	},
	"ko-KR": {
		htmlTest: "translation-ko.json",
		pluralTest: "translation-ko.json",
		strings: "translation-ko.json"
	},
	ml: {
		htmlTest: "translation-ml.json",
		pluralTest: "translation-ml.json",
		strings: "translation-ml.json"
	},
	"ml-IN": {
		htmlTest: "translation-ml.json",
		pluralTest: "translation-ml.json",
		strings: "translation-ml.json"
	},
	mr: {
		htmlTest: "translation-mr.json",
		pluralTest: "translation-mr.json",
		strings: "translation-mr.json"
	},
	"mr-IN": {
		htmlTest: "translation-mr.json",
		pluralTest: "translation-mr.json",
		strings: "translation-mr.json"
	},
	nl: {
		htmlTest: "translation-nl.json",
		pluralTest: "translation-nl.json",
		strings: "translation-nl.json"
	},
	"nl-BE": {
		htmlTest: "translation-nl.json",
		pluralTest: "translation-nl.json",
		strings: "translation-nl.json"
	},
	"nl-NL": {
		htmlTest: "translation-nl.json",
		pluralTest: "translation-nl.json",
		strings: "translation-nl.json"
	},
	pl: {
		htmlTest: "translation-pl.json",
		pluralTest: "translation-pl.json",
		strings: "translation-pl.json"
	},
	"pl-PL": {
		htmlTest: "translation-pl.json",
		pluralTest: "translation-pl.json",
		strings: "translation-pl.json"
	},
	pt: {
		htmlTest: "translation-pt.json",
		pluralTest: "translation-pt.json",
		strings: "translation-pt.json"
	},
	"pt-BR": {
		htmlTest: "translation-pt.json",
		pluralTest: "translation-pt.json",
		strings: "translation-pt.json"
	},
	"pt-PT": {
		htmlTest: "translation-pt.json",
		pluralTest: "translation-pt.json",
		strings: "translation-pt.json"
	},
	sv: {
		htmlTest: "translation-sv.json",
		pluralTest: "translation-sv.json",
		strings: "translation-sv.json"
	},
	"sv-SE": {
		htmlTest: "translation-sv.json",
		pluralTest: "translation-sv.json",
		strings: "translation-sv.json"
	},
	ta: {
		htmlTest: "translation-ta.json",
		pluralTest: "translation-ta.json",
		strings: "translation-ta.json"
	},
	"ta-IN": {
		htmlTest: "translation-ta.json",
		pluralTest: "translation-ta.json",
		strings: "translation-ta.json"
	},
	te: {
		htmlTest: "translation-te.json",
		pluralTest: "translation-te.json",
		strings: "translation-te.json"
	},
	"te-IN": {
		htmlTest: "translation-te.json",
		pluralTest: "translation-te.json",
		strings: "translation-te.json"
	},
	th: {
		htmlTest: "translation-th.json",
		pluralTest: "translation-th.json",
		strings: "translation-th.json"
	},
	"th-TH": {
		htmlTest: "translation-th.json",
		pluralTest: "translation-th.json",
		strings: "translation-th.json"
	},
	tr: {
		htmlTest: "translation-tr.json",
		pluralTest: "translation-tr.json",
		strings: "translation-tr.json"
	},
	"tr-TR": {
		htmlTest: "translation-tr.json",
		pluralTest: "translation-tr.json",
		strings: "translation-tr.json"
	},
	und: {
		htmlTest: "translation.json",
		pluralTest: "translation.json",
		strings: "translation.json"
	},
	zh: {
		htmlTest: "translation-zh.json",
		pluralTest: "translation-zh.json",
		strings: "translation-zh.json"
	},
	"zh-CN": {
		htmlTest: "translation-zh.json",
		pluralTest: "translation-zh.json",
		strings: "translation-zh.json"
	},
	"zh-TW": {
		htmlTest: "translation-zh.json",
		pluralTest: "translation-zh.json",
		strings: "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
